module.exports = __webpack_public_path__ + "125cc2617b6ab023c4efd5eafb27ba55.svg";